
function Sucess() {
    return (<>
        <div className={`bg-white border-2 border-border text-center w-4/5 mx-auto mt-10 p-4 h-72`}>
            <h1 className="font-poppins font-bold mx-auto text-3xl mt-4 bold md:text-2xl">Pesquisa Não Encontrada!</h1>
        </div>
    </>);
}

export default Sucess;